
import { defineComponent } from "vue"
import CardSeriesForm from "@/components/card_series/Form.vue"

export default defineComponent({
  components: {
    CardSeriesForm
  }
})
